import {
  EventDTO,
  FreightDTO,
  FromDTO,
  LegDTO,
  LocationDTO,
  ToDTO,
  TransportDTO,
  TransportTypeDTO,
} from "../api/response.types";
import { CardDates, DateTimeModel } from "entities/shared/shipmentCard.types";
import { Nullable } from "shared/lib/typeCheck.lib";

export type DateModel = Record<keyof typeof CardDates, Nullable<DateTimeModel>>;

export type RoadFromModel = FromDTO;

export type RoadToModel = ToDTO;

export type RoadFreightModel = FreightDTO;

export type RoadEventModel = EventDTO;

export type RoadTransformedEventModel = { location: string | null; events: RoadEventModel[] };

export type RoadLegModel = LegDTO;

export type RoadRouteModel = {
  from: RoadFromModel | null;
  to: RoadToModel | null;
} & DateModel;

export type RoadTransportModel = TransportDTO;

export type RoadLocationModel = LocationDTO;

export const RoadTransportTypeModel = {
  ...TransportTypeDTO,
} as const;
